import Component from 'vue-class-component'
import { Vue, Mixins } from 'vue-property-decorator'
import axios from 'axios';
import SnackbarService from './snackbar-service';

@Component
class AuthService extends Mixins(SnackbarService) {

  getLogin(username: string, password: string) {
    const bodyFormData = new FormData();
    bodyFormData.append('username', username);
    bodyFormData.append('password', password);
    return axios({
      method: 'post',
      url: '/login',
      data: bodyFormData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  registrate(email: string, username: string, password: string, promoCode: string) {
    const payload: any = {
      email,
      username,
      password,
    }
    if (promoCode !== '') {
      payload['promo_code'] = promoCode
    }
    return axios({
      method: 'post',
      url: '/registrate',
      data: payload,
      headers: { 'Content-Type': 'multipart/form-data' },
    })  
  }

  getUser() {
    return this.getUserRequest()
      .then((res: any) => {
        this.$store.state.user = res.data
      })
      .catch((error: any) => {
        this.$router.push('/login')
      })
      .finally(() => {
        this.$store.state.loading = false
      })
  }

  getUserRequest() {
    return axios.get('/users/me')
  }

  refreshToken() {
    axios.get('refresh-token').then((res: any) => {
      localStorage.setItem('accessToken',res.data.access_token )
    })
  }

  verifyRegistrationToken(token: string) {
    return axios.get(`/verify-registration/${token}`)
  }

  checkExists(type: string, value: string) {
    const payload: any = {}
    payload[type] = value;
    return axios.post(`exists/${type}`, payload)
  }

  getAccount(userId: number) {
    return axios.get(`accounts/${userId}`)
  }

  updateAccount() {
    const userId = this.$store.state.user.id
    axios.get(`accounts/${userId}`).then((res: any) => {
      this.$store.state.account = res.data;
    })
  }

  sendPasswordResetEmail(email: string) {
    const paylad = {
      email,
    }
    return axios({
      method: 'post',
      url: '/send-reset-password-email',
      data: paylad,
      headers: { 'Content-Type': 'multipart/form-data' },
    })  
  }

  sendResetPassword(password: string, token: string) {
    const paylad = {
      password,
      token
    }
    return axios({
      method: 'post',
      url: '/reset-password',
      data: paylad,
      headers: { 'Content-Type': 'multipart/form-data' },
    })    
  }

  sendUpdateUsername(username: string) {
    const paylad = {
      username,
    }
    return axios({
      method: 'post',
      url: '/update-username',
      data: paylad,
      headers: { 'Content-Type': 'multipart/form-data' },
    })    
  }

  sendUpdatePassword(password: string) {
    const paylad = {
      password,
    }
    return axios({
      method: 'post',
      url: '/update-password',
      data: paylad,
      headers: { 'Content-Type': 'multipart/form-data' },
    })    
  }

  loginLiveDemo() {
    this.$store.state.loading = true;
    this.getLogin('Live Demo', 'live-demo')
      .then((res: any) => {
        const token = res.data.access_token
        this.$store.state.token = token
        this.getUser().then(() => {
          this.getAccount(this.$store.state.user.account_id).then(
            (res: any) => {
              this.$store.state.account = res.data
              if (this.$store.state.account.farms.length > 0) {
                this.$store.state.selectedFarmId = this.$store.state.account.farms[0].id
              }
              this.$store.state.loading = false
            }
          )
        })
        this.$router.push('home')
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          this.notify({ text: `Wrong username or password` })
        } else if (error.response.status === 403) {
          this.notify({
            text: `Please open your email account and click on the registration link`,
            type: 'warning',
            timeout: 10000,
          })
        } else if (error.response.status === 423) {
          this.notify({
            text: `Your account is deactivated`,
            type: 'warning',
            timeout: 10000,
          })
        } else {
          this.notify({ text: `Error trying to login ${error}` })
        }
      })
      .finally(() => {
        this.$store.state.loading = false
      })
  }

  savePayment(payment: string, months: number) {
    const paylad = {
      payment,
      months
    }
    return axios({
      method: 'post',
      url: '/save-payment',
      data: paylad,
      headers: { 'Content-Type': 'multipart/form-data' },
    })    
  }
  
}
export default AuthService
